import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UI from 'components/UI'
import UIDatePicker, { DatePickerProps } from "components/datepicker";
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import BooleanUtil from "utils/BooleanUtil";
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UITextArea from 'components/atoms/textarea/UITextArea';
import ValidationUtil from "common/validation/util/ValidationUtil"
//메뉴등록 페이지
function ContentsContainer() {

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20)
	const [codeValueId,setCodeValueId] = useState('')  
	const [codeGroupId,setCodeGroupId] = useState('')

	const [codeGroupUseYn,setCodeGroupUseYn] = useState(true);
	const [codeGroup,setCodeGroup] = useState('')
	const [codeGroupNm,setCodeGroupNm] = useState('')
	const [codeGroupUseYnNm,setCodeGroupUseYnNm] = useState('')
	const [codeGroupDc,setCodeGroupDc] = useState('')
	const [codeValueDc,setCodeValueDc] = useState('')
	let [inputCount, setInputCount] = useState(0);

	
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	/**ibsheet 세팅  */
    //초기 데이터 설정

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 2,
				//"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"
			},
			Def:{
				Row:{
				//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"},
			
			],
			// "LeftCols": [
			// 	{"Header": ["No","No"],"Name": "SEQ","Type": "Int","Width": 40,"ColMerge": 0}
			//   ],
			"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": "코드 값" ,"Type": "Text","Name": "CODE_VALUE","RelWidth": 1,"Align": "Center","CanEdit": "1"},
			{"Header": "코드 값 이름","Type": "Text","Name": "CODE_VALUE_NM","RelWidth": 2,"Align": "Left","CanEdit": "1"},
			{"Header": "코드 값 설명","Type": "Text","Name": "CODE_VALUE_DC","RelWidth": 2,"Align": "Left","CanEdit": "1"},
			{"Header": "코드 값 사용여부","Type": "Enum","Name": "CODE_VALUE_USE_YN","RelWidth": 0.5,"Align": "Center","CanEdit": 1,"Enum": "|사용|미사용","EnumKeys": "|1|0"},
			]
				 
		},
		//시트 이벤트
		'event':{
				
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[{
			CODE_VALUE:""
			,CODE_VALUE_NM:""
			,CODE_VALUE_DC:""
			,USE_YN:"0"
		}]
	}
	
	//====== 그리드 공통 부  END
	
	

	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './adm6410',  
			state: { data: receivedData }
		});
	}

	//리스트에 변경내용 저장
	async function codeSave (){
		
		// if (!ValidationUtil.checkAll()) {
		// 	return;
		// }

		if(codeGroup === "" || codeGroupNm === "") {
			await UIUtils.alert('필수 입력값 입력해주세요.');
			return;
		}

		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))) {
			let codeAddItems: {CODE_VALUE:string; CODE_VALUE_NM:string;CODE_VALUE_DC:string;USE_YN:string; }[] = [];
			// @ts-ignore
			let codeAddItem: { CODE_VALUE:string; CODE_VALUE_NM:string;CODE_VALUE_DC:string;USE_YN:string; } = {};

			// @ts-ignore
			var rows = sheet.getDataRows();
			for (var i = 0; i < rows.length; i++) {	
				let codeVal = rows[i]["CODE_VALUE"];
				let codeValNm = rows[i]["CODE_VALUE_NM"];
				if(StringUtil.isNotEmpty(codeVal) && StringUtil.isNotEmpty(codeValNm)) {
					// @ts-ignore
					codeAddItem = {
						CODE_VALUE: codeVal,
						CODE_VALUE_NM: codeValNm,
						CODE_VALUE_DC: rows[i]["CODE_VALUE_DC"],
						USE_YN: StringUtil.isNotEmpty(rows[i]["CODE_VALUE_USE_YN"]) ? rows[i]["CODE_VALUE_USE_YN"] : 0
					};
					codeAddItems.push(codeAddItem);
				}
			}

			let param = {
				"CODE_GROUP":codeGroup
				,"CODE_GROUP_NM":codeGroupNm
				,"CODE_GROUP_DC":codeGroupDc
				,"USE_YN":(codeGroupUseYn+'' === 'true') ? 1 : 0
				,"CODE_VALUE_LIST":codeAddItems
			}
			console.log(JSON.stringify(param));

			const response:any = await CommonUtil.execute({
				url:'adm_6413_codeSave',
				data: param
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});
			
			if(response) {
				console.log('adm_6413_codeSave result  : ' + JSON.stringify(response.CODE_GROUP_ID));
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				let vCODE_GROUP_ID = response.CODE_GROUP_ID;
				let dataToSend = { vCODE_GROUP_ID }
				// 상세 페이지로 데이터 전달
				history.push({
					pathname: './adm6411',
					state: { data: dataToSend }
				});
			}
		}
	}

	//행 추가
	const rowAdd = (e) => {
		//@ts-ignore
		//sheet.copyRow({row: sheet.getFocusedRow()});
		sheet.addRow({ visible: 1 });
		//@ts-ignore
		sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
	} 

	// 행 삭제
	const rowDel = (e) => {
		//@ts-ignore
		sheet.removeRow({row:sheet.getFocusedRow()});
		//sheet.deleteRow(sheet.getFocusedRow());
		//@ts-ignore
		sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 

	//글자 수 체크 및 입력제한 
	const onTextareaHandler = (inputValue) => {
		// if(authorDc != ""){
		// 	inputValue = authorDc;
		// }
		if(inputCount == 4000){
           UIUtils.alert("4000자 이하로 입력해 주세요.").then();
		   return;
		}
			setInputCount(inputValue.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length);
			setCodeGroupDc(inputValue);
	};

	// init 
	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/common/yesNo", "/common/useYn");

		//ib시트 생성
		ib.create();

	
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
		 
        }
    },[])
	

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">코드관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">코드 등록</h1>
						<form className="fo fo-col3" name="" action="" method="">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">코드그룹</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={codeGroup} valueChanged={(value) => setCodeGroup(value)} rules={["required"]}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">코드그룹 이름</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeGroupNm} valueChanged={(value) => setCodeGroupNm(value)} rules={["required"]}/>
									</div>
								</div>

								<div className="fo-item req">
									<p className="fo-key">사용여부</p>
									<div className="fo-value">
										<div className="hz-root hz-gap15 h36">
											<UI.Radios
											    className="check"
												value={codeGroupUseYn}
												valueChanged={(value) => setCodeGroupUseYn(value)}
												codeData={codeDataStore.get("/common/useYn")}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">코드그룹 설명</p>
									<div className="fo-value">
										<div className="ta w100p">
											<UITextArea className={'ta-ip'}  value={codeGroupDc} valueChanged={(value) => onTextareaHandler(value)} attrs={{ rows: 5 }}/>
											<div>
												<p className="tx tx-cp1 mt5">
													<em className="fc-err">{inputCount}</em> Bytes / 
													<em className="fc-err">4,000</em> Bytes
												</p>
											</div>
										</div>
									</div>
								</div>													
							
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">코드값 목록</p>
									<div className="fo-value d-block"> 
									<div className="tb-top">
										<div>
											<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
											</div>
											<div className="hz-root hz-gap5">
												<Button color="gray-o" size="sm" onClick={rowDel}>- 삭제</Button>
												<Button color="gray-o" size="sm" onClick={rowAdd}>+ 추가</Button>
											</div>
										</div>
										<div id='sheetDiv' className="ibsheet" >[D] IBSHEET 영역</div>
									</div>
								</div>											

							</div>
						</form>
						<div className="hz-root hz-right hz-gap5">
							<Button color="pri-o" size="sm" onClick={codeSave} >저장</Button>
							<Button color="gray-o" size="sm" onClick={goList}>목록</Button>
						</div>
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;